import { gql } from 'apollo-angular'

export const GET_HISTORY_NOTIFICATION_LIST = gql`
  query AdminEscape_HitoryNotifications(
    $options: AdminEscapeHitoryNotificationListOptions
  ) {
    adminEscape_HitoryNotifications(options: $options) {
      totalItems
      totalBooking
      totalReconciliation
      totalOther
      totalUnread
      items {
        id
        createdAt
        updatedAt
        title
        body
        notificationBy
        type
        isRead
        userId
        description
        data
        notificationCategory
      }
    }
  }
`

export const READ_ALL_NOTIFICATIONS = gql`
  mutation ReadAllNotification {
    readAllNotification {
      ... on SuccessMessage {
        message
        status
        errorCode
      }
      ... on CommonErrorResult {
        errorCode
        message
      }
    }
  }
`

export const READ_NOTIFICATION = gql`
  mutation ReadSingleNotification($notificationId: ID!) {
    readSingleNotification(notificationId: $notificationId) {
      ... on CommonErrorResult {
        errorCode
        message
      }
      ... on SuccessMessage {
        message
        status
        errorCode
      }
    }
  }
`
